import React from 'react';

export default function Splash() {
  return (
    <div className="splash-screen" role="status" aria-label="Loading MyTownly Rides">
      <img
        src={`${process.env.PUBLIC_URL || ''}/icons/splash-portrait.png`}
        alt="MyTownly Rides"
        className="splash-portrait-img"
        fetchPriority="high"
      />
    </div>
  );
}
